import { render } from "./AppointmentDataForm.vue?vue&type=template&id=6601ce9a&scoped=true&ts=true"
import script from "./AppointmentDataForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentDataForm.vue?vue&type=script&lang=ts"

import "./AppointmentDataForm.vue?vue&type=style&index=0&id=6601ce9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601ce9a"]])

export default __exports__